import { useCallback, useEffect, useState } from "react";
import { Camera, ImagePlus } from "lucide-react";
import { api } from "../../lib/api";
import { logger } from "../../lib/logger";
import { GalleryUploadForm } from "./GalleryUploadForm";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const Photo = ({ p, i }) => (
  <figure className={`relative overflow-hidden rounded-xl border border-[color:var(--border)] bg-black group ${i % 5 === 0 ? "sm:col-span-2 sm:row-span-2" : ""}`} data-testid={`gallery-photo-${p.id}`}>
    <img src={`${BACKEND}${p.url}`} alt={p.caption || `Photo du cours ${p.course_name}`} loading="lazy" className="w-full h-full object-cover aspect-square group-hover:scale-105 transition-transform duration-500" />
    <figcaption className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/90 to-transparent text-xs">
      {p.caption && <div className="text-white line-clamp-2">{p.caption}</div>}
      <div className="flex items-center gap-1.5 text-[10px] text-white/70 mt-0.5"><span className="w-1.5 h-1.5 rounded-full" style={{ background: p.color || "var(--accent)" }} />{p.course_name} · {p.author}</div>
    </figcaption>
  </figure>
);

export const FamilyGallery = ({ courses }) => {
  const [data, setData] = useState({ items: [], total: 0 });
  const [open, setOpen] = useState(false);
  const load = useCallback(() => { api.get("/courses/gallery").then(r => setData(r.data)).catch(err => logger.warn("[gallery] load failed:", err)); }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <section id="galerie" className="space-y-6 scroll-mt-24" data-testid="family-gallery">
      <div className="flex items-end gap-6 flex-wrap">
        <div className="flex-1 min-w-[260px]">
          <div className="text-xs uppercase tracking-[0.3em] text-[color:var(--accent)] mb-2 flex items-center gap-2"><Camera className="w-3.5 h-3.5" /> Galerie des familles</div>
          <h2 className="font-display text-4xl sm:text-5xl leading-none">Vos photos, notre scène.</h2>
          <p className="text-sm text-[color:var(--text-muted)] mt-2 max-w-2xl">Parents, partagez un instant de cours : chaque photo est validée par la régie avant d'apparaître ici.</p>
        </div>
        <button type="button" onClick={() => setOpen(o => !o)} data-testid="gallery-open-upload" className="inline-flex items-center gap-2 border border-[color:var(--accent)] text-[color:var(--accent)] hover:bg-[color:var(--accent)] hover:text-black px-5 py-2.5 rounded-full text-xs uppercase tracking-widest transition-colors">
          <ImagePlus className="w-4 h-4" /> Envoyer une photo
        </button>
      </div>
      {open && <GalleryUploadForm courses={courses} onClose={() => setOpen(false)} />}
      {data.items.length === 0
        ? <div className="glass rounded-2xl p-10 text-center text-sm text-[color:var(--text-muted)]" data-testid="gallery-empty">Les premières photos de la saison arrivent bientôt. Famille inscrite ? Sois la première à partager un souvenir !</div>
        : <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 stagger" data-testid="gallery-grid">{data.items.map((p, i) => <Photo key={p.id} p={p} i={i} />)}</div>}
    </section>
  );
};
